/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateOpenShiftRequest } from '../api-models';
// @ts-ignore
import { GetAvailableOpeningsRequest } from '../api-models';
// @ts-ignore
import { OpenShiftConfiguration } from '../api-models';
// @ts-ignore
import { OpeningAvailabilityData } from '../api-models';
// @ts-ignore
import { PostedShiftEmployee } from '../api-models';
// @ts-ignore
import { PostedShiftsResponse } from '../api-models';
// @ts-ignore
import { TupleOfBooleanAndCreateOpenShiftResponse } from '../api-models';
/**
 * OpenShiftApi - axios parameter creator
 * @export
 */
export const OpenShiftApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GetAvailableOpeningsRequest} [getAvailableOpeningsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftAutoOpenshiftsPost: async (getAvailableOpeningsRequest?: GetAvailableOpeningsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpenShift/auto-openshifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAvailableOpeningsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAvailableOpeningsRequest} [getAvailableOpeningsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftAvailableOpeningsPost: async (getAvailableOpeningsRequest?: GetAvailableOpeningsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpenShift/available-openings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAvailableOpeningsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftConfigGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpenShift/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OpenShiftConfiguration} [openShiftConfiguration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftConfigPut: async (openShiftConfiguration?: OpenShiftConfiguration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpenShift/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openShiftConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOpenShiftRequest} [createOpenShiftRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftPost: async (createOpenShiftRequest?: CreateOpenShiftRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpenShift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOpenShiftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [openingId] 
         * @param {string} [openingDate] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftPostedShiftEmployeesGet: async (openingId?: number, openingDate?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpenShift/posted-shift-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (openingId !== undefined) {
                localVarQueryParameter['openingId'] = openingId;
            }

            if (openingDate !== undefined) {
                localVarQueryParameter['openingDate'] = (openingDate as any instanceof Date) ?
                    (openingDate as any).toISOString() :
                    openingDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {Array<number>} [positionIds] 
         * @param {number} [unitId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [search] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftPostedShiftsGet: async (facilityId?: number, departmentId?: number, positionIds?: Array<number>, unitId?: number, startDate?: string, endDate?: string, search?: string, pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpenShift/posted-shifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (positionIds) {
                localVarQueryParameter['positionIds'] = positionIds;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpenShiftApi - functional programming interface
 * @export
 */
export const OpenShiftApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpenShiftApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GetAvailableOpeningsRequest} [getAvailableOpeningsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openShiftAutoOpenshiftsPost(getAvailableOpeningsRequest?: GetAvailableOpeningsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openShiftAutoOpenshiftsPost(getAvailableOpeningsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAvailableOpeningsRequest} [getAvailableOpeningsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openShiftAvailableOpeningsPost(getAvailableOpeningsRequest?: GetAvailableOpeningsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpeningAvailabilityData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openShiftAvailableOpeningsPost(getAvailableOpeningsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openShiftConfigGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenShiftConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openShiftConfigGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OpenShiftConfiguration} [openShiftConfiguration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openShiftConfigPut(openShiftConfiguration?: OpenShiftConfiguration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openShiftConfigPut(openShiftConfiguration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateOpenShiftRequest} [createOpenShiftRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openShiftPost(createOpenShiftRequest?: CreateOpenShiftRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TupleOfBooleanAndCreateOpenShiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openShiftPost(createOpenShiftRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [openingId] 
         * @param {string} [openingDate] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openShiftPostedShiftEmployeesGet(openingId?: number, openingDate?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostedShiftEmployee>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openShiftPostedShiftEmployeesGet(openingId, openingDate, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {Array<number>} [positionIds] 
         * @param {number} [unitId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [search] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openShiftPostedShiftsGet(facilityId?: number, departmentId?: number, positionIds?: Array<number>, unitId?: number, startDate?: string, endDate?: string, search?: string, pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostedShiftsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openShiftPostedShiftsGet(facilityId, departmentId, positionIds, unitId, startDate, endDate, search, pageNumber, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OpenShiftApi - factory interface
 * @export
 */
export const OpenShiftApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpenShiftApiFp(configuration)
    return {
        /**
         * 
         * @param {OpenShiftApiOpenShiftAutoOpenshiftsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftAutoOpenshiftsPost(requestParameters: OpenShiftApiOpenShiftAutoOpenshiftsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.openShiftAutoOpenshiftsPost(requestParameters.getAvailableOpeningsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpenShiftApiOpenShiftAvailableOpeningsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftAvailableOpeningsPost(requestParameters: OpenShiftApiOpenShiftAvailableOpeningsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<OpeningAvailabilityData>> {
            return localVarFp.openShiftAvailableOpeningsPost(requestParameters.getAvailableOpeningsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftConfigGet(options?: AxiosRequestConfig): AxiosPromise<OpenShiftConfiguration> {
            return localVarFp.openShiftConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpenShiftApiOpenShiftConfigPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftConfigPut(requestParameters: OpenShiftApiOpenShiftConfigPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.openShiftConfigPut(requestParameters.openShiftConfiguration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpenShiftApiOpenShiftPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftPost(requestParameters: OpenShiftApiOpenShiftPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<TupleOfBooleanAndCreateOpenShiftResponse> {
            return localVarFp.openShiftPost(requestParameters.createOpenShiftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpenShiftApiOpenShiftPostedShiftEmployeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftPostedShiftEmployeesGet(requestParameters: OpenShiftApiOpenShiftPostedShiftEmployeesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<PostedShiftEmployee>> {
            return localVarFp.openShiftPostedShiftEmployeesGet(requestParameters.openingId, requestParameters.openingDate, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpenShiftApiOpenShiftPostedShiftsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openShiftPostedShiftsGet(requestParameters: OpenShiftApiOpenShiftPostedShiftsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PostedShiftsResponse> {
            return localVarFp.openShiftPostedShiftsGet(requestParameters.facilityId, requestParameters.departmentId, requestParameters.positionIds, requestParameters.unitId, requestParameters.startDate, requestParameters.endDate, requestParameters.search, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for openShiftAutoOpenshiftsPost operation in OpenShiftApi.
 * @export
 * @interface OpenShiftApiOpenShiftAutoOpenshiftsPostRequest
 */
export interface OpenShiftApiOpenShiftAutoOpenshiftsPostRequest {
    /**
     * 
     * @type {GetAvailableOpeningsRequest}
     * @memberof OpenShiftApiOpenShiftAutoOpenshiftsPost
     */
    readonly getAvailableOpeningsRequest?: GetAvailableOpeningsRequest
}

/**
 * Request parameters for openShiftAvailableOpeningsPost operation in OpenShiftApi.
 * @export
 * @interface OpenShiftApiOpenShiftAvailableOpeningsPostRequest
 */
export interface OpenShiftApiOpenShiftAvailableOpeningsPostRequest {
    /**
     * 
     * @type {GetAvailableOpeningsRequest}
     * @memberof OpenShiftApiOpenShiftAvailableOpeningsPost
     */
    readonly getAvailableOpeningsRequest?: GetAvailableOpeningsRequest
}

/**
 * Request parameters for openShiftConfigPut operation in OpenShiftApi.
 * @export
 * @interface OpenShiftApiOpenShiftConfigPutRequest
 */
export interface OpenShiftApiOpenShiftConfigPutRequest {
    /**
     * 
     * @type {OpenShiftConfiguration}
     * @memberof OpenShiftApiOpenShiftConfigPut
     */
    readonly openShiftConfiguration?: OpenShiftConfiguration
}

/**
 * Request parameters for openShiftPost operation in OpenShiftApi.
 * @export
 * @interface OpenShiftApiOpenShiftPostRequest
 */
export interface OpenShiftApiOpenShiftPostRequest {
    /**
     * 
     * @type {CreateOpenShiftRequest}
     * @memberof OpenShiftApiOpenShiftPost
     */
    readonly createOpenShiftRequest?: CreateOpenShiftRequest
}

/**
 * Request parameters for openShiftPostedShiftEmployeesGet operation in OpenShiftApi.
 * @export
 * @interface OpenShiftApiOpenShiftPostedShiftEmployeesGetRequest
 */
export interface OpenShiftApiOpenShiftPostedShiftEmployeesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof OpenShiftApiOpenShiftPostedShiftEmployeesGet
     */
    readonly openingId?: number

    /**
     * 
     * @type {string}
     * @memberof OpenShiftApiOpenShiftPostedShiftEmployeesGet
     */
    readonly openingDate?: string

    /**
     * 
     * @type {string}
     * @memberof OpenShiftApiOpenShiftPostedShiftEmployeesGet
     */
    readonly search?: string
}

/**
 * Request parameters for openShiftPostedShiftsGet operation in OpenShiftApi.
 * @export
 * @interface OpenShiftApiOpenShiftPostedShiftsGetRequest
 */
export interface OpenShiftApiOpenShiftPostedShiftsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof OpenShiftApiOpenShiftPostedShiftsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof OpenShiftApiOpenShiftPostedShiftsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof OpenShiftApiOpenShiftPostedShiftsGet
     */
    readonly positionIds?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof OpenShiftApiOpenShiftPostedShiftsGet
     */
    readonly unitId?: number

    /**
     * 
     * @type {string}
     * @memberof OpenShiftApiOpenShiftPostedShiftsGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof OpenShiftApiOpenShiftPostedShiftsGet
     */
    readonly endDate?: string

    /**
     * 
     * @type {string}
     * @memberof OpenShiftApiOpenShiftPostedShiftsGet
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof OpenShiftApiOpenShiftPostedShiftsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof OpenShiftApiOpenShiftPostedShiftsGet
     */
    readonly pageSize?: number
}

/**
 * OpenShiftApi - object-oriented interface
 * @export
 * @class OpenShiftApi
 * @extends {BaseAPI}
 */
export class OpenShiftApi extends BaseAPI {
    /**
     * 
     * @param {OpenShiftApiOpenShiftAutoOpenshiftsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenShiftApi
     */
    public openShiftAutoOpenshiftsPost(requestParameters: OpenShiftApiOpenShiftAutoOpenshiftsPostRequest = {}, options?: AxiosRequestConfig) {
        return OpenShiftApiFp(this.configuration).openShiftAutoOpenshiftsPost(requestParameters.getAvailableOpeningsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpenShiftApiOpenShiftAvailableOpeningsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenShiftApi
     */
    public openShiftAvailableOpeningsPost(requestParameters: OpenShiftApiOpenShiftAvailableOpeningsPostRequest = {}, options?: AxiosRequestConfig) {
        return OpenShiftApiFp(this.configuration).openShiftAvailableOpeningsPost(requestParameters.getAvailableOpeningsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenShiftApi
     */
    public openShiftConfigGet(options?: AxiosRequestConfig) {
        return OpenShiftApiFp(this.configuration).openShiftConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpenShiftApiOpenShiftConfigPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenShiftApi
     */
    public openShiftConfigPut(requestParameters: OpenShiftApiOpenShiftConfigPutRequest = {}, options?: AxiosRequestConfig) {
        return OpenShiftApiFp(this.configuration).openShiftConfigPut(requestParameters.openShiftConfiguration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpenShiftApiOpenShiftPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenShiftApi
     */
    public openShiftPost(requestParameters: OpenShiftApiOpenShiftPostRequest = {}, options?: AxiosRequestConfig) {
        return OpenShiftApiFp(this.configuration).openShiftPost(requestParameters.createOpenShiftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpenShiftApiOpenShiftPostedShiftEmployeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenShiftApi
     */
    public openShiftPostedShiftEmployeesGet(requestParameters: OpenShiftApiOpenShiftPostedShiftEmployeesGetRequest = {}, options?: AxiosRequestConfig) {
        return OpenShiftApiFp(this.configuration).openShiftPostedShiftEmployeesGet(requestParameters.openingId, requestParameters.openingDate, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpenShiftApiOpenShiftPostedShiftsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenShiftApi
     */
    public openShiftPostedShiftsGet(requestParameters: OpenShiftApiOpenShiftPostedShiftsGetRequest = {}, options?: AxiosRequestConfig) {
        return OpenShiftApiFp(this.configuration).openShiftPostedShiftsGet(requestParameters.facilityId, requestParameters.departmentId, requestParameters.positionIds, requestParameters.unitId, requestParameters.startDate, requestParameters.endDate, requestParameters.search, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
